import { MDText } from 'i18n-react';

import { Button, HelpIcon, IconComponentProps } from '@motorway/mw-highway-code';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import { useVehicleCollectionStatusSub } from '../../hooks/useVehicleCollectionStatusSub';
import { MarkAsCollectedActionCenter } from '../../MarkAsCollectedActionCenter/MarkAsCollectedActionCenter';
import { shouldShowMarkAsCollectedActionCenter } from '../../utils/showElementStatusChecker';
import { vehicleCollectionStore } from '../../VehicleCollectionSubjects';

import Texts from './SaleDetails.texts.json';
import { SaleDetailsContent } from './SaleDetailsContent';

import styles from './SaleDetails.scss';

const localT = new MDText(Texts);

export const SaleDetails = () => {
  const status = useVehicleCollectionStatusSub();
  const showMarkAsCollectedActionCenter = shouldShowMarkAsCollectedActionCenter(status);

  const openSaleSupportModal = () => {
    vehicleCollectionStore.setIsSaleSupportModalOpen(true);

    POST_SALE_SNOW_PLOW_EVENTS.HELP_MODAL_SALE_DETAILS_OPENED();
  };

  return (
    <div className={styles.saleDetails}>
      <div className={styles.actionButtonsContainer}>
        {showMarkAsCollectedActionCenter && <MarkAsCollectedActionCenter />}
        <Button fullWidth reverse icon={(props: IconComponentProps) => <HelpIcon filled={false} {...props} />} label={localT.translate('buttons.saleHelp')} onClick={openSaleSupportModal} variant='secondary' />
      </div>
      <SaleDetailsContent title={localT.translate('title.saleDetails')} variant='card' />
    </div>
  );
};
